import { getAccessTokenFromAppState } from '../../utils'

const DEFAULT_TIMEOUT_MS = 60000
const DEFAULT_INTERVAL_MS = 1000

const isAvailable = (url) => {
  return new Promise((resolve, _reject) => {
    fetch(url, {
      headers: {
        Authorization: `Bearer ${getAccessTokenFromAppState()}`,
      },
    })
      .then((response) => {
        return response.status === 200
          ? Promise.resolve(response)
          : Promise.reject(new Error('Error polling merged pdf process'))
      })
      .then((response) => {
        return response.json()
      })
      .then((responseJson) => {
        resolve(responseJson.ready === true)
      })
      .catch(() => {
        resolve(false)
      })
  })
}

const doPolling = ({ url, mergedDocumentId, endTime, intervalMs, timeoutMs }) => {
  return new Promise((resolve, reject) => {
    if (Date.now() < endTime) {
      isAvailable(url).then((available) => {
        if (available) {
          resolve(mergedDocumentId)
        } else {
          setTimeout(() => {
            doPolling({ url, mergedDocumentId, endTime, intervalMs, timeoutMs })
              .then(() => resolve(mergedDocumentId))
              .catch((error) => reject(error))
          }, intervalMs)
        }
      })
    } else {
      reject(new Error(`Timeout of ${timeoutMs} ms reached`))
    }
  })
}

export function pollUntilReady(
  url,
  mergedDocumentId,
  timeoutMs = DEFAULT_TIMEOUT_MS,
  intervalMs = DEFAULT_INTERVAL_MS,
) {
  const endTime = Date.now() + timeoutMs
  return doPolling({ url, mergedDocumentId, endTime, intervalMs, timeoutMs })
}
